// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --slope: 55deg;
    --text-margin: 5px;
    --text-margin-hovered: 2px;
    --diagonal-text-hover-offset: calc(-1 * (var(--text-margin) + var(--text-margin-hovered)));
}

body,
html {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

#paper {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: start;
    border: 1px solid #ccc;
    background-color: #F7F8F9;
}

#toolbar {
    position: absolute;
    box-sizing: border-box;
    top: 8px;
    left: 8px;
    background: white;
    padding: 8px;
    border: 1px solid #E0E0E0;
    border-radius: 6px;
    min-height: 50px;
    display: flex;
    align-items: center;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);

    output {
        text-align: center;
        font-size: 12px;
        background: #F4F6F7;
        color: #64748B;
        border-radius: 50%;
        padding: 6px;
        margin: 0 6px;
        width: 20px;
    }

    button,
    label {
        outline: none;
        background: #FFFFFF;
        text-align: center;
        letter-spacing: 0.25px;
        font-size: 14px;
        color: #222222;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none
    }

    button {
        padding: 6px 12px;
        border: 1px solid #E0E0E0;
        border-radius: 6px;
        margin-left: 6px;
        transition: background-color 0.2s ease-in-out;
    }

    label {
        padding-right: 12px;
        padding-top: 6px;
        padding-bottom: 6px;
        font-size: 11px;
        color: #75757D;
    }

    button:not(:disabled):hover {
        background-color: #F4F6F7;
    }

    button:disabled {
        color: #B0B0B0;
        cursor: not-allowed;
    }

    .joint-toolbar {
        :first-child {
            margin-left: 0;
        }
    }

    .joint-widget[data-type="separator"] {
        margin: 0 8px;
    }

    .joint-widget::before {
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }

    .joint-widget[data-type="undo"]::before {
        content: url('assets/undo-icon.svg');
    }

    .joint-widget[data-type="redo"]::before {
        content: url('assets/redo-icon.svg');
    }

    .joint-widget[data-type="zoomIn"]::before {
        content: url('assets/zoom-in-icon.svg');
    }

    .joint-widget[data-type="zoomOut"]::before {
        content: url('assets/zoom-out-icon.svg');
    }

    .joint-widget[data-type="zoomToFit"]::before {
        content: url('assets/zoom-to-fit-icon.svg');
    }

    .joint-widget:disabled::before {
        opacity: 0.5;
    }

    /*********** Baseline, reset styles ***********/
    input[type="range"] {
        -webkit-appearance: none;
        appearance: none;
        background: transparent;
        cursor: pointer;
        width: 5rem;
    }

    /* Removes default focus */
    input[type="range"]:focus {
        outline: none;
    }

    /******** Chrome, Safari, Opera and Edge Chromium styles ********/
    /* slider track */
    input[type="range"]::-webkit-slider-runnable-track {
        background-color: #E8EFF1;
        border-radius: 0.5rem;
        height: 0.5rem;
        transition: background-color 0.2s ease-in-out;
    }

    /* slider thumb */
    input[type="range"]::-webkit-slider-thumb {
        -webkit-appearance: none;
        /* Override default look */
        appearance: none;
        margin-top: -4px;
        /* Centers thumb on the track */
        background-color: #808080;
        border-radius: 0.5rem;
        height: 1rem;
        width: 1rem;
        transition: background-color 0.2s ease-in-out;
    }

    input[type="range"]:hover::-webkit-slider-runnable-track {
        background-color: #A4DDF0;
    }

    input[type="range"]:hover::-webkit-slider-thumb {
        background-color: #333;
    }

    /*********** Firefox styles ***********/
    /* slider track */
    input[type="range"]::-moz-range-track {
        background-color: #E8EFF1;
        border-radius: 0.5rem;
        height: 0.5rem;
        transition: background-color 0.2s ease-in-out;
    }

    /* slider thumb */
    input[type="range"]::-moz-range-thumb {
        background-color: #808080;
        border: none;
        /*Removes extra border that FF applies*/
        border-radius: 0.5rem;
        height: 1rem;
        width: 1rem;
        transition: background-color 0.2s ease-in-out;
    }

    input[type="range"]:hover::-moz-range-track {
        background-color: #A4DDF0;
    }

    input[type="range"]:hover::-moz-range-thumb {
        background-color: #333;
    }
}

/* Inspector styles */

#inspector {

    overflow: visible;

    .object-properties {
        display: flex;
    }

    .list-item {
        display: flex;
        padding: 4px;
        gap: 12px;

        .btn-list-del {
            align-self: flex-end;
            min-width: 36px;
            height: 32px;
            margin: 0;
            background-color: #F3F6F7;
            border-radius: 6px;
            border: 1px solid #000000;
            font-size: 0;
            /* Hide the text that's part of the button */
            transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;
        }

        .btn-list-del:hover {
            box-shadow: 0 0 0 3px #A4DDF0;
            border-color: #1B8BBB;
        }

        .btn-list-del:focus {
            outline: none;
            border-color: #1B8BBB;
            box-shadow: 0 0 0 3px #A4DDF0;
        }

        .btn-list-del::before {
            content: url('assets/close-icon.svg');
            width: 16px;
            height: 16px;
        }
    }

    .field {
        padding: 0;
        font-size: 14px;

        label {
            font-size: 14px;
            color: #64748B;
        }
    }

    .field .content-editable {
        white-space: pre-wrap;
        overflow-wrap: break-word;
        word-break: break-word;
        max-width: 100%;
        min-width: 0;
        display: inline-block;
        box-sizing: border-box;
        width: 100%;
        min-height: 44px;
        padding: 12px;
        border: 1px solid #000;
        border-radius: 6px;
        transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;

        &:hover,
        &:focus {
            border-color: #1B8BBB;
            box-shadow: 0 0 0 3px #A4DDF0;
        }

        &:focus {
            outline: none;
        }
    }

    .field.list-field>label {
        color: #020817;
    }

    .field.list-field {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 8px;

        .btn-list-add {
            position: absolute;
            right: 0;
            top: 0;
            margin: 0;
            font-size: 0;
            height: 32px;
            background-color: #F3F6F7;
            border-radius: 6px;
            border: 1px solid #000000;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 0 10px;
            /* Hide the text that's part of the button */
            transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;
        }

        .btn-list-add:hover {
            box-shadow: 0 0 0 3px #A4DDF0;
            border-color: #1B8BBB;
        }

        .btn-list-add:focus {
            outline: none;
            border-color: #1B8BBB;
            box-shadow: 0 0 0 3px #A4DDF0;
        }

        .btn-list-add::before {
            content: url('assets/add-icon.svg');
            width: 16px;
            height: 16px;
        }

        .btn-list-add::after {
            content: 'Add';
            font-size: 14px;
            color: #464A53;
        }
    }

    .list-item {
        flex-direction: row-reverse;
        padding: 0;

        .field.content-editable-field .input-wrapper .content-editable {
            padding-top: 6px;
            padding-bottom: 6px;
            min-height: 32px;
        }
    }

    .list-item:nth-child(n + 2) {
        margin-top: 12px;
    }

    .field.object-field {
        flex-grow: 1;
        justify-self: stretch;
    }

    .object-property {
        flex-grow: 1;
        margin: 0;

        div {
            flex-grow: 1;
        }
    }

    .field.select-button-group-field .joint-select-button-group {
        display: flex;
        gap: 6px;
        align-items: center;

        .select-button-group-button {
            padding: 4px 12px;
            border-radius: 6px;
            border: 1px solid #333333;
            background-color: #F3F6F7;
            transition:
                box-shadow 0.2s ease-in-out,
                background-color 0.2s ease-in-out,
                color 0.2s ease-in-out,
                border-color 0.2s ease-in-out;
        }

        .select-button-group-button:hover {
            box-shadow: 0 0 0 3px #A4DDF0;
            border-color: #1B8BBB;
        }

        .select-button-group-button.selected {
            background-color: #1B8BBB;
            color: white;
            border-color: transparent;
        }
    }
}

#inspector>.field:nth-child(n + 2) {
    margin-top: 16px;
}

/* Dialog styles */
.joint-dialog .fg {
    background-color: white;
    top: 50%;
    transform: translateY(-50%);
    box-sizing: border-box;
    border-radius: 8px;
    border: 3px solid #000000;

    .titlebar {
        color: #020817;
        background-color: #A4DDF0;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 14px;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        font-weight: bolder;
    }

    button.btn-close {
        height: 0;
        width: 0;
        padding: 0;
        margin: 0;
        border: none;

        &::before {
            position: absolute;
            left: -24px;
            top: 10px;
            width: 16px;
            height: 16px;
            content: url('assets/close-icon.svg');
        }
    }

    .body {
        padding: 16px 14px;
    }

    .controls {
        padding: 14px;
        display: flex;
        justify-content: flex-end;
        gap: 12px;

        button {
            height: 32px;
            padding: 0 16px;
            border-radius: 6px;
            cursor: pointer;
            transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;
        }

        button.btn-cancel {
            background-color: #F3F6F7;
            color: #464A53;
            border: 1px solid #333333;
        }

        button.btn-cancel:hover {
            box-shadow: 0 0 0 3px #A4DDF0;
            border-color: #1B8BBB;
        }

        button.btn-cancel:focus {
            outline: none;
            border-color: #1B8BBB;
            box-shadow: 0 0 0 3px #A4DDF0;
        }

        button.btn-save {
            background-color: #1B8BBB;
            color: white;
            border: none;
        }

        button.btn-save:hover {
            box-shadow: 0 0 0 3px #A4DDF0;
            border-color: #1B8BBB;
        }

        button.btn-save:focus {
            outline: none;
            border-color: #1B8BBB;
            box-shadow: 0 0 0 3px #A4DDF0;
        }
    }
}

/* Diagram styles */
.joint-element {
    /* Diagonal rotation groups (no transition on rotation) */
    & > .label-shift-top {
        --off: calc(var(--text-margin) * -1);
        transform-box: fill-box;
        transform-origin: right center;
        transform: rotate(var(--slope)) translateX(var(--off));
        transition: transform 0.2s ease-in-out;
    }

    & > .label-shift-bottom {
        --off: calc(var(--text-margin) * -1);
        transform-box: fill-box;
        transform-origin: right center;
        transform: rotate(calc(-1 * var(--slope))) translateX(var(--off));
        transition: transform 0.2s ease-in-out;
    }

    /* Regular horizontal labels */
    & > .label-shift {
        transition: transform 0.2s ease-in-out;
    }

    & > .floating-group {
        transition: transform 0.2s ease-in-out;
    }

    /* Hover/selected states */
    &:hover,
    &.selected {
        & > .label-shift-top {
            transform: rotate(var(--slope)) translateX(calc(var(--off) - var(--text-margin-hovered)));
        }

        & > .label-shift-bottom {
            transform: rotate(calc(-1 * var(--slope))) translateX(calc(var(--off) - var(--text-margin-hovered)));
        }

        & > .label-shift {
            transform: translateX(calc(var(--text-margin-hovered) * -1));
        }

        & > .floating-group {
            transform: translate(calc(var(--text-margin-hovered) * -1), calc(var(--text-margin-hovered) * -1));
        }
    }
}
`, "",{"version":3,"sources":["webpack://./styles.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;IAClB,0BAA0B;IAC1B,0FAA0F;AAC9F;;AAEA;;IAEI,8BAA8B;IAC9B,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,+CAA+C;;IAE/C;QACI,kBAAkB;QAClB,eAAe;QACf,mBAAmB;QACnB,cAAc;QACd,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,WAAW;IACf;;IAEA;;QAEI,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,sBAAsB;QACtB,eAAe;QACf,cAAc;QACd,eAAe;QACf,yBAAyB;QACzB,sBAAsB;QACtB,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB,yBAAyB;QACzB,kBAAkB;QAClB,gBAAgB;QAChB,6CAA6C;IACjD;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI;YACI,cAAc;QAClB;IACJ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,YAAY;IAChB;;IAEA,+CAA+C;IAC/C;QACI,wBAAwB;QACxB,gBAAgB;QAChB,uBAAuB;QACvB,eAAe;QACf,WAAW;IACf;;IAEA,0BAA0B;IAC1B;QACI,aAAa;IACjB;;IAEA,iEAAiE;IACjE,iBAAiB;IACjB;QACI,yBAAyB;QACzB,qBAAqB;QACrB,cAAc;QACd,6CAA6C;IACjD;;IAEA,iBAAiB;IACjB;QACI,wBAAwB;QACxB,0BAA0B;QAC1B,gBAAgB;QAChB,gBAAgB;QAChB,+BAA+B;QAC/B,yBAAyB;QACzB,qBAAqB;QACrB,YAAY;QACZ,WAAW;QACX,6CAA6C;IACjD;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA,uCAAuC;IACvC,iBAAiB;IACjB;QACI,yBAAyB;QACzB,qBAAqB;QACrB,cAAc;QACd,6CAA6C;IACjD;;IAEA,iBAAiB;IACjB;QACI,yBAAyB;QACzB,YAAY;QACZ,uCAAuC;QACvC,qBAAqB;QACrB,YAAY;QACZ,WAAW;QACX,6CAA6C;IACjD;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA,qBAAqB;;AAErB;;IAEI,iBAAiB;;IAEjB;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,SAAS;;QAET;YACI,oBAAoB;YACpB,eAAe;YACf,YAAY;YACZ,SAAS;YACT,yBAAyB;YACzB,kBAAkB;YAClB,yBAAyB;YACzB,YAAY;YACZ,4CAA4C;YAC5C,sEAAsE;QAC1E;;QAEA;YACI,6BAA6B;YAC7B,qBAAqB;QACzB;;QAEA;YACI,aAAa;YACb,qBAAqB;YACrB,6BAA6B;QACjC;;QAEA;YACI,qCAAqC;YACrC,WAAW;YACX,YAAY;QAChB;IACJ;;IAEA;QACI,UAAU;QACV,eAAe;;QAEf;YACI,eAAe;YACf,cAAc;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB,yBAAyB;QACzB,sBAAsB;QACtB,eAAe;QACf,YAAY;QACZ,qBAAqB;QACrB,sBAAsB;QACtB,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,sEAAsE;;QAEtE;;YAEI,qBAAqB;YACrB,6BAA6B;QACjC;;QAEA;YACI,aAAa;QACjB;IACJ;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,QAAQ;;QAER;YACI,kBAAkB;YAClB,QAAQ;YACR,MAAM;YACN,SAAS;YACT,YAAY;YACZ,YAAY;YACZ,yBAAyB;YACzB,kBAAkB;YAClB,yBAAyB;YACzB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,QAAQ;YACR,eAAe;YACf,4CAA4C;YAC5C,sEAAsE;QAC1E;;QAEA;YACI,6BAA6B;YAC7B,qBAAqB;QACzB;;QAEA;YACI,aAAa;YACb,qBAAqB;YACrB,6BAA6B;QACjC;;QAEA;YACI,mCAAmC;YACnC,WAAW;YACX,YAAY;QAChB;;QAEA;YACI,cAAc;YACd,eAAe;YACf,cAAc;QAClB;IACJ;;IAEA;QACI,2BAA2B;QAC3B,UAAU;;QAEV;YACI,gBAAgB;YAChB,mBAAmB;YACnB,gBAAgB;QACpB;IACJ;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,YAAY;QACZ,SAAS;;QAET;YACI,YAAY;QAChB;IACJ;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,mBAAmB;;QAEnB;YACI,iBAAiB;YACjB,kBAAkB;YAClB,yBAAyB;YACzB,yBAAyB;YACzB;;;;6CAIiC;QACrC;;QAEA;YACI,6BAA6B;YAC7B,qBAAqB;QACzB;;QAEA;YACI,yBAAyB;YACzB,YAAY;YACZ,yBAAyB;QAC7B;IACJ;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,uBAAuB;IACvB,QAAQ;IACR,2BAA2B;IAC3B,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;;IAEzB;QACI,cAAc;QACd,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,eAAe;QACf,2BAA2B;QAC3B,4BAA4B;QAC5B,mBAAmB;IACvB;;IAEA;QACI,SAAS;QACT,QAAQ;QACR,UAAU;QACV,SAAS;QACT,YAAY;;QAEZ;YACI,kBAAkB;YAClB,WAAW;YACX,SAAS;YACT,WAAW;YACX,YAAY;YACZ,qCAAqC;QACzC;IACJ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,aAAa;QACb,yBAAyB;QACzB,SAAS;;QAET;YACI,YAAY;YACZ,eAAe;YACf,kBAAkB;YAClB,eAAe;YACf,sEAAsE;QAC1E;;QAEA;YACI,yBAAyB;YACzB,cAAc;YACd,yBAAyB;QAC7B;;QAEA;YACI,6BAA6B;YAC7B,qBAAqB;QACzB;;QAEA;YACI,aAAa;YACb,qBAAqB;YACrB,6BAA6B;QACjC;;QAEA;YACI,yBAAyB;YACzB,YAAY;YACZ,YAAY;QAChB;;QAEA;YACI,6BAA6B;YAC7B,qBAAqB;QACzB;;QAEA;YACI,aAAa;YACb,qBAAqB;YACrB,6BAA6B;QACjC;IACJ;AACJ;;AAEA,mBAAmB;AACnB;IACI,yDAAyD;IACzD;QACI,oCAAoC;QACpC,uBAAuB;QACvB,8BAA8B;QAC9B,sDAAsD;QACtD,sCAAsC;IAC1C;;IAEA;QACI,oCAAoC;QACpC,uBAAuB;QACvB,8BAA8B;QAC9B,iEAAiE;QACjE,sCAAsC;IAC1C;;IAEA,8BAA8B;IAC9B;QACI,sCAAsC;IAC1C;;IAEA;QACI,sCAAsC;IAC1C;;IAEA,0BAA0B;IAC1B;;QAEI;YACI,yFAAyF;QAC7F;;QAEA;YACI,oGAAoG;QACxG;;QAEA;YACI,4DAA4D;QAChE;;QAEA;YACI,kGAAkG;QACtG;IACJ;AACJ","sourcesContent":[":root {\n    --slope: 55deg;\n    --text-margin: 5px;\n    --text-margin-hovered: 2px;\n    --diagonal-text-hover-offset: calc(-1 * (var(--text-margin) + var(--text-margin-hovered)));\n}\n\nbody,\nhtml {\n    font-family: Arial, sans-serif;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\n#paper {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    text-align: start;\n    border: 1px solid #ccc;\n    background-color: #F7F8F9;\n}\n\n#toolbar {\n    position: absolute;\n    box-sizing: border-box;\n    top: 8px;\n    left: 8px;\n    background: white;\n    padding: 8px;\n    border: 1px solid #E0E0E0;\n    border-radius: 6px;\n    min-height: 50px;\n    display: flex;\n    align-items: center;\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);\n\n    output {\n        text-align: center;\n        font-size: 12px;\n        background: #F4F6F7;\n        color: #64748B;\n        border-radius: 50%;\n        padding: 6px;\n        margin: 0 6px;\n        width: 20px;\n    }\n\n    button,\n    label {\n        outline: none;\n        background: #FFFFFF;\n        text-align: center;\n        letter-spacing: 0.25px;\n        font-size: 14px;\n        color: #222222;\n        cursor: pointer;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none\n    }\n\n    button {\n        padding: 6px 12px;\n        border: 1px solid #E0E0E0;\n        border-radius: 6px;\n        margin-left: 6px;\n        transition: background-color 0.2s ease-in-out;\n    }\n\n    label {\n        padding-right: 12px;\n        padding-top: 6px;\n        padding-bottom: 6px;\n        font-size: 11px;\n        color: #75757D;\n    }\n\n    button:not(:disabled):hover {\n        background-color: #F4F6F7;\n    }\n\n    button:disabled {\n        color: #B0B0B0;\n        cursor: not-allowed;\n    }\n\n    .joint-toolbar {\n        :first-child {\n            margin-left: 0;\n        }\n    }\n\n    .joint-widget[data-type=\"separator\"] {\n        margin: 0 8px;\n    }\n\n    .joint-widget::before {\n        width: 16px;\n        height: 16px;\n        margin-right: 8px;\n    }\n\n    .joint-widget[data-type=\"undo\"]::before {\n        content: url('assets/undo-icon.svg');\n    }\n\n    .joint-widget[data-type=\"redo\"]::before {\n        content: url('assets/redo-icon.svg');\n    }\n\n    .joint-widget[data-type=\"zoomIn\"]::before {\n        content: url('assets/zoom-in-icon.svg');\n    }\n\n    .joint-widget[data-type=\"zoomOut\"]::before {\n        content: url('assets/zoom-out-icon.svg');\n    }\n\n    .joint-widget[data-type=\"zoomToFit\"]::before {\n        content: url('assets/zoom-to-fit-icon.svg');\n    }\n\n    .joint-widget:disabled::before {\n        opacity: 0.5;\n    }\n\n    /*********** Baseline, reset styles ***********/\n    input[type=\"range\"] {\n        -webkit-appearance: none;\n        appearance: none;\n        background: transparent;\n        cursor: pointer;\n        width: 5rem;\n    }\n\n    /* Removes default focus */\n    input[type=\"range\"]:focus {\n        outline: none;\n    }\n\n    /******** Chrome, Safari, Opera and Edge Chromium styles ********/\n    /* slider track */\n    input[type=\"range\"]::-webkit-slider-runnable-track {\n        background-color: #E8EFF1;\n        border-radius: 0.5rem;\n        height: 0.5rem;\n        transition: background-color 0.2s ease-in-out;\n    }\n\n    /* slider thumb */\n    input[type=\"range\"]::-webkit-slider-thumb {\n        -webkit-appearance: none;\n        /* Override default look */\n        appearance: none;\n        margin-top: -4px;\n        /* Centers thumb on the track */\n        background-color: #808080;\n        border-radius: 0.5rem;\n        height: 1rem;\n        width: 1rem;\n        transition: background-color 0.2s ease-in-out;\n    }\n\n    input[type=\"range\"]:hover::-webkit-slider-runnable-track {\n        background-color: #A4DDF0;\n    }\n\n    input[type=\"range\"]:hover::-webkit-slider-thumb {\n        background-color: #333;\n    }\n\n    /*********** Firefox styles ***********/\n    /* slider track */\n    input[type=\"range\"]::-moz-range-track {\n        background-color: #E8EFF1;\n        border-radius: 0.5rem;\n        height: 0.5rem;\n        transition: background-color 0.2s ease-in-out;\n    }\n\n    /* slider thumb */\n    input[type=\"range\"]::-moz-range-thumb {\n        background-color: #808080;\n        border: none;\n        /*Removes extra border that FF applies*/\n        border-radius: 0.5rem;\n        height: 1rem;\n        width: 1rem;\n        transition: background-color 0.2s ease-in-out;\n    }\n\n    input[type=\"range\"]:hover::-moz-range-track {\n        background-color: #A4DDF0;\n    }\n\n    input[type=\"range\"]:hover::-moz-range-thumb {\n        background-color: #333;\n    }\n}\n\n/* Inspector styles */\n\n#inspector {\n\n    overflow: visible;\n\n    .object-properties {\n        display: flex;\n    }\n\n    .list-item {\n        display: flex;\n        padding: 4px;\n        gap: 12px;\n\n        .btn-list-del {\n            align-self: flex-end;\n            min-width: 36px;\n            height: 32px;\n            margin: 0;\n            background-color: #F3F6F7;\n            border-radius: 6px;\n            border: 1px solid #000000;\n            font-size: 0;\n            /* Hide the text that's part of the button */\n            transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;\n        }\n\n        .btn-list-del:hover {\n            box-shadow: 0 0 0 3px #A4DDF0;\n            border-color: #1B8BBB;\n        }\n\n        .btn-list-del:focus {\n            outline: none;\n            border-color: #1B8BBB;\n            box-shadow: 0 0 0 3px #A4DDF0;\n        }\n\n        .btn-list-del::before {\n            content: url('assets/close-icon.svg');\n            width: 16px;\n            height: 16px;\n        }\n    }\n\n    .field {\n        padding: 0;\n        font-size: 14px;\n\n        label {\n            font-size: 14px;\n            color: #64748B;\n        }\n    }\n\n    .field .content-editable {\n        white-space: pre-wrap;\n        overflow-wrap: break-word;\n        word-break: break-word;\n        max-width: 100%;\n        min-width: 0;\n        display: inline-block;\n        box-sizing: border-box;\n        width: 100%;\n        min-height: 44px;\n        padding: 12px;\n        border: 1px solid #000;\n        border-radius: 6px;\n        transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;\n\n        &:hover,\n        &:focus {\n            border-color: #1B8BBB;\n            box-shadow: 0 0 0 3px #A4DDF0;\n        }\n\n        &:focus {\n            outline: none;\n        }\n    }\n\n    .field.list-field>label {\n        color: #020817;\n    }\n\n    .field.list-field {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n\n        .btn-list-add {\n            position: absolute;\n            right: 0;\n            top: 0;\n            margin: 0;\n            font-size: 0;\n            height: 32px;\n            background-color: #F3F6F7;\n            border-radius: 6px;\n            border: 1px solid #000000;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 8px;\n            padding: 0 10px;\n            /* Hide the text that's part of the button */\n            transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;\n        }\n\n        .btn-list-add:hover {\n            box-shadow: 0 0 0 3px #A4DDF0;\n            border-color: #1B8BBB;\n        }\n\n        .btn-list-add:focus {\n            outline: none;\n            border-color: #1B8BBB;\n            box-shadow: 0 0 0 3px #A4DDF0;\n        }\n\n        .btn-list-add::before {\n            content: url('assets/add-icon.svg');\n            width: 16px;\n            height: 16px;\n        }\n\n        .btn-list-add::after {\n            content: 'Add';\n            font-size: 14px;\n            color: #464A53;\n        }\n    }\n\n    .list-item {\n        flex-direction: row-reverse;\n        padding: 0;\n\n        .field.content-editable-field .input-wrapper .content-editable {\n            padding-top: 6px;\n            padding-bottom: 6px;\n            min-height: 32px;\n        }\n    }\n\n    .list-item:nth-child(n + 2) {\n        margin-top: 12px;\n    }\n\n    .field.object-field {\n        flex-grow: 1;\n        justify-self: stretch;\n    }\n\n    .object-property {\n        flex-grow: 1;\n        margin: 0;\n\n        div {\n            flex-grow: 1;\n        }\n    }\n\n    .field.select-button-group-field .joint-select-button-group {\n        display: flex;\n        gap: 6px;\n        align-items: center;\n\n        .select-button-group-button {\n            padding: 4px 12px;\n            border-radius: 6px;\n            border: 1px solid #333333;\n            background-color: #F3F6F7;\n            transition:\n                box-shadow 0.2s ease-in-out,\n                background-color 0.2s ease-in-out,\n                color 0.2s ease-in-out,\n                border-color 0.2s ease-in-out;\n        }\n\n        .select-button-group-button:hover {\n            box-shadow: 0 0 0 3px #A4DDF0;\n            border-color: #1B8BBB;\n        }\n\n        .select-button-group-button.selected {\n            background-color: #1B8BBB;\n            color: white;\n            border-color: transparent;\n        }\n    }\n}\n\n#inspector>.field:nth-child(n + 2) {\n    margin-top: 16px;\n}\n\n/* Dialog styles */\n.joint-dialog .fg {\n    background-color: white;\n    top: 50%;\n    transform: translateY(-50%);\n    box-sizing: border-box;\n    border-radius: 8px;\n    border: 3px solid #000000;\n\n    .titlebar {\n        color: #020817;\n        background-color: #A4DDF0;\n        height: 44px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0 14px;\n        border-top-left-radius: 6px;\n        border-top-right-radius: 6px;\n        font-weight: bolder;\n    }\n\n    button.btn-close {\n        height: 0;\n        width: 0;\n        padding: 0;\n        margin: 0;\n        border: none;\n\n        &::before {\n            position: absolute;\n            left: -24px;\n            top: 10px;\n            width: 16px;\n            height: 16px;\n            content: url('assets/close-icon.svg');\n        }\n    }\n\n    .body {\n        padding: 16px 14px;\n    }\n\n    .controls {\n        padding: 14px;\n        display: flex;\n        justify-content: flex-end;\n        gap: 12px;\n\n        button {\n            height: 32px;\n            padding: 0 16px;\n            border-radius: 6px;\n            cursor: pointer;\n            transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;\n        }\n\n        button.btn-cancel {\n            background-color: #F3F6F7;\n            color: #464A53;\n            border: 1px solid #333333;\n        }\n\n        button.btn-cancel:hover {\n            box-shadow: 0 0 0 3px #A4DDF0;\n            border-color: #1B8BBB;\n        }\n\n        button.btn-cancel:focus {\n            outline: none;\n            border-color: #1B8BBB;\n            box-shadow: 0 0 0 3px #A4DDF0;\n        }\n\n        button.btn-save {\n            background-color: #1B8BBB;\n            color: white;\n            border: none;\n        }\n\n        button.btn-save:hover {\n            box-shadow: 0 0 0 3px #A4DDF0;\n            border-color: #1B8BBB;\n        }\n\n        button.btn-save:focus {\n            outline: none;\n            border-color: #1B8BBB;\n            box-shadow: 0 0 0 3px #A4DDF0;\n        }\n    }\n}\n\n/* Diagram styles */\n.joint-element {\n    /* Diagonal rotation groups (no transition on rotation) */\n    & > .label-shift-top {\n        --off: calc(var(--text-margin) * -1);\n        transform-box: fill-box;\n        transform-origin: right center;\n        transform: rotate(var(--slope)) translateX(var(--off));\n        transition: transform 0.2s ease-in-out;\n    }\n\n    & > .label-shift-bottom {\n        --off: calc(var(--text-margin) * -1);\n        transform-box: fill-box;\n        transform-origin: right center;\n        transform: rotate(calc(-1 * var(--slope))) translateX(var(--off));\n        transition: transform 0.2s ease-in-out;\n    }\n\n    /* Regular horizontal labels */\n    & > .label-shift {\n        transition: transform 0.2s ease-in-out;\n    }\n\n    & > .floating-group {\n        transition: transform 0.2s ease-in-out;\n    }\n\n    /* Hover/selected states */\n    &:hover,\n    &.selected {\n        & > .label-shift-top {\n            transform: rotate(var(--slope)) translateX(calc(var(--off) - var(--text-margin-hovered)));\n        }\n\n        & > .label-shift-bottom {\n            transform: rotate(calc(-1 * var(--slope))) translateX(calc(var(--off) - var(--text-margin-hovered)));\n        }\n\n        & > .label-shift {\n            transform: translateX(calc(var(--text-margin-hovered) * -1));\n        }\n\n        & > .floating-group {\n            transform: translate(calc(var(--text-margin-hovered) * -1), calc(var(--text-margin-hovered) * -1));\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
